import Skeleton from '@mui/material/Skeleton';
import { PieChart } from '@mui/x-charts/PieChart';
import * as React from 'react';

export type PieChartData = {
  id: string;
  value: number;
  label: string;
}[];

export const sliceColours = [
  '#6CA9FF',
  '#8563B0',
  '#D57F84',
  '#2D8285',
  '#EDA832',
  '#63B06D',
  '#9F9F9F'
];

export const PIE_CHART_HEIGHT = 600;

/**
 * A pie chart component which renders the first 6 values with a color, and the seventh value in grey.
 */
export default function Top6PieChart(props: { data: PieChartData; loading: boolean }) {
  const { data, loading } = props;

  if (loading) {
    return <Skeleton variant="rectangular" height={PIE_CHART_HEIGHT} />;
  }

  return (
    <PieChart
      margin={{ top: 0, bottom: 0, left: 0, right: 40 }}
      colors={sliceColours}
      series={[
        {
          data,
          innerRadius: '30%'
        }
      ]}
      height={PIE_CHART_HEIGHT}
      slotProps={{
        legend: {
          hidden: true
        }
      }}
    />
  );
}
